var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.sticky ? 'mainNav sticky-nav' : 'mainNav']},[_c('nav',{staticClass:"navbar navbar-light fixed-top"},[_c('div',{staticClass:"navbar-container"},[_vm._t("logo"),_vm._v(" "),_c('div',{on:{"click":_vm.MenuToggler}},[_vm._t("toggler")],2),_vm._v(" "),_vm._t("default")],2)])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28fa68ca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/MainNav.vue
// module id = jj+p
// module chunks = 0 1